import {
  englishDataset,
  englishRecommendedTransformers,
  RegExpMatcher,
} from 'obscenity'
import { SPRINT_NAME_DENYLIST } from './denylist.js'

const matcher = new RegExpMatcher({
  ...englishDataset.build(),
  ...englishRecommendedTransformers,
})

function escapeRegExp(term: string): string {
  return term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

// Word-boundary anchored, same as obscenity's own matching: a substring
// check here would let a short denylist entry (e.g. "ass") reject any word
// that merely contains it (e.g. "class") - the Scunthorpe problem.
const denylistPatterns = SPRINT_NAME_DENYLIST.map(
  (term) => new RegExp(`\\b${escapeRegExp(term)}\\b`, 'i'),
)

/**
 * True if `text` contains profanity, per the `obscenity` library's English
 * dataset (leetspeak/confusables/case aware) plus the repo-owned
 * {@link SPRINT_NAME_DENYLIST}.
 *
 * Run this over the *composed* name ("Slippery Owl"), not just its parts —
 * two clean words can still read rude joined together, and this checks the
 * whole string rather than each word in isolation.
 */
export function isProfane(text: string): boolean {
  if (matcher.hasMatch(text)) {
    return true
  }

  return denylistPatterns.some((pattern) => pattern.test(text))
}
